import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import MKTypography from "components/MKTypography";
import { useTranslation } from "react-i18next";

function SimpleClientDesc({ clientKey, sections }) {
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t(`clients.${clientKey}.desc.title`)}
      </MKTypography>
      <Grid container spacing={2}>
        {sections.map((sectionKey) => (
          <Grid key={sectionKey} item xs={12} md={6}>
            <Stack spacing={0.75}>
              <MKTypography variant="h6" fontWeight="bold">
                {t(`clients.${clientKey}.desc.${sectionKey}Title`)}
              </MKTypography>
              <MKTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
                {t(`clients.${clientKey}.desc.${sectionKey}Body`)}
              </MKTypography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

SimpleClientDesc.defaultProps = {
  sections: ["section1", "section2"],
};

SimpleClientDesc.propTypes = {
  clientKey: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(PropTypes.string),
};

export default SimpleClientDesc;
